import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { DatePicker } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import Signature from '../../../Components/Signature'
import { CloseIcon } from '@chakra-ui/icons'
import { modals } from '../../../Components/Modal'

export default function CRNAANSList({
  index,
  errors,
  register,
  control,
  data,
  crnaansQuestion,
  setValue,
  watch,
  trigger,
  remove,
  isCreate,
  reviewerOptions,
}) {
  const [isConfirm, setIsConfirm] = useState(false)
  const onRemove = () => setIsConfirm(true)

  return (
    <>
      {modals.confirm({
        isOpen: isConfirm,
        onClose: () => setIsConfirm(false),
        onSubmit: () => {
          setIsConfirm(false)
          remove(index)
        },
      })}
      {index !== 0 && (
        <hr
          style={{
            backgroundColor: 'black',
            height: 1,
            margin: '16px 0px',
          }}
        />
      )}
      <Box>
        <Center>
          <FormControl
            id="performed"
            style={{
              width: '20%',
              marginBottom: '12px',
            }}
          >
            <FormLabel>Performed by provider</FormLabel>
            <Input
              name={`form.performed`}
              defaultValue={data?.performed || '0'}
              type="number"
              ref={register()}
            />
          </FormControl>
        </Center>
        <HStack>
          <FormControl
            id="anesthesia"
            isRequired
            isInvalid={errors?.form?.list?.[index]?.anesthesia}
          >
            <FormLabel>Peer Review</FormLabel>
            <Input
              name={`form.list.${index}.anesthesia`}
              placeholder="Peer Review"
              ref={register({
                required: 'Peer Review required.',
              })}
              defaultValue={data?.list?.[index]?.anesthesia || ''}
            />
          </FormControl>
          <FormControl
            id="period"
            isRequired
            defaultValue={
              data?.list?.[index]?.period
                ? moment(data?.list?.[index]?.period)
                : moment()
            }
            isInvalid={errors?.form?.list?.[index]?.period}
          >
            <FormLabel>Period</FormLabel>

            <Controller
              render={props => (
                <DatePicker
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  value={props?.value}
                  picker="quarter"
                  onChange={props.onChange}
                  format={'Y-[Q]Q'}
                />
              )}
              name={`form.list.${index}.period`}
              control={control}
              rules={{ required: 'Period required.' }}
              defaultValue={moment()}
            />
            <FormErrorMessage>
              {errors?.form?.list?.[index]?.date &&
                errors?.form?.list?.[index]?.date?.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl id="mr" isRequired isInvalid={errors?.mr}>
            <FormLabel>MR#</FormLabel>
            <Input
              name={`form.list.${index}.mr`}
              placeholder="MR#"
              ref={register({
                required: 'MR# required.',
              })}
              defaultValue={data?.list?.[index]?.mr ?? ''}
            />
          </FormControl>
          <FormControl isRequired isInvalid={errors?.form?.list?.[index]?.dos}>
            <FormLabel>DOS</FormLabel>
            <Controller
              render={props => (
                <DatePicker
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  value={props?.value}
                  onChange={props?.onChange}
                />
              )}
              name={`form.list.${index}.dos`}
              control={control}
              rules={{ required: 'DOS is required.' }}
              defaultValue={
                data?.list?.[index]?.dos
                  ? moment(data?.list?.[index]?.dos)
                  : moment()
              }
            />
          </FormControl>
        </HStack>
      </Box>
      <Text fontSize="xl" fontWeight="bold" my={6}>
        ANESTHESIA PROVIDER PEER/UTILIZATION REVIEW CRITERIA
      </Text>
      <Box>
        {crnaansQuestion.map((question, qIndex) => (
          <Flex
            key={qIndex}
            justifyContent="space-between"
            my={4}
            pl={qIndex === 3 ? 8 : 0}
          >
            <Text fontSize={18}>
              {qIndex !== 3 ? `${qIndex > 3 ? qIndex : qIndex + 1}.` : 'a.'}
              {question}
            </Text>
            <Flex gap={8}>
              <FormControl
                isInvalid={
                  errors?.form?.list?.[index]?.answers &&
                  errors?.form?.list?.[index]?.answers[qIndex]
                }
              >
                <Controller
                  render={props => (
                    <RadioGroup onChange={props.onChange} value={props.value}>
                      <Stack direction="row">
                        <Radio value="yes">Yes</Radio>
                        <Radio value="no">No</Radio>
                      </Stack>
                    </RadioGroup>
                  )}
                  name={`form.list.${index}.answers[${qIndex}]`}
                  control={control}
                  rules={{ required: isCreate }}
                  defaultValue={data?.list?.[index]?.answers?.[qIndex] || ''}
                />
              </FormControl>
            </Flex>
          </Flex>
        ))}
      </Box>
      <Box mt={12}>
        <FormControl>
          <Text mb="8px">Comment: </Text>
          <Controller
            render={props => (
              <Textarea
                value={props.value}
                placeholder="Comment"
                onChange={props.onChange}
              />
            )}
            name={`form.list.${index}.comment`}
            control={control}
            defaultValue={data?.list?.[index]?.comment || ''}
          />
        </FormControl>
      </Box>

      <SimpleGrid columns={2} spacingX="40px" spacingY="20px">
        <Box>
          <Controller
            name={`form.list.${index}.signatureCollector`}
            control={control}
            defaultValue={data?.signatureCollector || ''}
            rules={{
              required: { value: isCreate, message: 'Signature is required.' },
            }}
            render={({ field }) => {
              return (
                <FormControl
                  w="30vw"
                  isInvalid={errors?.form?.list?.[index]?.signatureCollector}
                >
                  <Signature
                    label="Peer Reviewer Signature"
                    field={field}
                    setValue={setValue}
                    watch={watch}
                    data={data?.list?.[index]?.signatureCollector}
                    trigger={trigger}
                    formKey={`form.list.${index}.signatureCollector`}
                    isRequired={errors?.form?.list?.[index]?.signatureCollector}
                  />
                  <FormErrorMessage>
                    {errors?.form?.list?.[index]?.signatureCollector &&
                      errors?.form?.list?.[index]?.signatureCollector.message}
                  </FormErrorMessage>
                </FormControl>
              )
            }}
          />
        </Box>
        <Box display={'flex'} alignItems={'end'}>
          <FormControl isRequired={isCreate}>
            <FormLabel>Date</FormLabel>
            <Controller
              render={props => (
                <Input
                  value={props.value}
                  onChange={props.onChange}
                  isReadOnly
                  textAlign={'center'}
                />
              )}
              name={`form.list.${index}.date`}
              control={control}
              defaultValue={
                isCreate
                  ? moment().format('YYYY-MM-DD')
                  : data?.list?.[index]?.date || ''
              }
              rules={{
                required: { value: isCreate, message: 'Date is required.' },
              }}
            />
          </FormControl>
        </Box>
        <Box>
          <FormControl id="reviewer">
            <FormLabel>Peer Reviewer Printed Name:</FormLabel>
            <Select
              name={`form.list.${index}.reviewer`}
              placeholder="Peer Reviewer Printed Name"
              ref={register()}
              defaultValue={data?.list?.[index]?.reviewer || ''}
            >
              {reviewerOptions?.map(item => (
                <option key={item.id} value={item.fullName}>
                  {item.fullName}
                </option>
              ))}
            </Select>
          </FormControl>
        </Box>
      </SimpleGrid>
      <Button
        mt={8}
        mb={4}
        variant="outline"
        leftIcon={<CloseIcon />}
        onClick={() => onRemove()}
        colorScheme="red"
      >
        Remove
      </Button>
    </>
  )
}
